<template>
  <div class="left-panel">
    <img class="logo-img" src="./logo.png" alt="logo" width="56" height="56">
    <ul class="name-wrapper">
      <li :class="{'active':userid==item.userid}" @click="sendChangeStudent(item)" class="name-item"
          v-for="item in studentsList">
        {{item.username}}
      </li>
    </ul>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    props: {
      studentsList: {
        type: Array
      },
      userid: {
        type: String
      }
    },
    methods: {
      sendChangeStudent(item) {
        this.$emit('changeStudent', item.userid)
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .left-panel {
    position: relative;
    width: 196px;
    height: 100%;
    float: left;
    background: #d6d8f3;
    .logo-img {
      margin: 10px 19px
    }
    .name-wrapper {
      margin-top: 20px;
      .name-item {
        font-size: 14px;
        text-algn: left;
        padding-left: 66px;
        color: #333;
        line-height: 66px;
        height: 66px;
        background: url('./avatar.png') no-repeat left 15px center / 36px 36px
        overflow: hidden
        white-space: nowrap
        text-overflow: ellipsis
        cursor: pointer
        &.active {
          background: #c2c5e8 url('./avatar.png') no-repeat left 15px center / 36px 36px
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/homework/leftpanelWithStudent.vue